import { render, staticRenderFns } from "./PinPreview.vue?vue&type=template&id=8e383716&scoped=true&"
import script from "./PinPreview.vue?vue&type=script&lang=js&"
export * from "./PinPreview.vue?vue&type=script&lang=js&"
import style0 from "./PinPreview.vue?vue&type=style&index=0&id=8e383716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e383716",
  null
  
)

export default component.exports